var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#959595;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,1.8c8.7,0,15.8,7.1,15.8,15.8s-7.1,15.8-15.8,15.8S1.8,26.2,1.8,17.5S8.8,1.8,17.5,1.8 M17.5,0 C7.8,0,0,7.8,0,17.5C0,27.2,7.8,35,17.5,35C27.2,35,35,27.2,35,17.5C35,7.8,27.2,0,17.5,0L17.5,0z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,8.6c1.1-0.2,1.7,1,2.3,1.8c0.5,0.8,1.1,1.7,0.9,2.8c-0.1,0.6-0.7,0.9-1.1,1.2c-0.4,0.3-1,0.7-1.1,1.2 c-0.2,0.8,0.3,1.7,0.6,2.2c0.7,1.1,1.6,2.2,2.7,3.1c0.5,0.4,1.3,1,2.1,0.9c1.1-0.2,1.4-1.6,2.7-1.8c1.2-0.2,2,0.7,2.6,1.2 c0.6,0.6,1.7,1.3,1.6,2.2c0,0.5-0.5,0.9-0.9,1.2c-0.4,0.3-0.7,0.7-1.1,1c-0.9,0.6-2,0.9-3.3,0.9c-1.3,0-2.3-0.5-3.2-1 c-1.8-1-3.2-2.3-4.5-3.8c-1.3-1.5-2.5-3.2-3.2-5.2c-0.8-2.4-0.4-4.9,1-6.4c0.2-0.3,0.6-0.5,0.9-0.8C11.8,9,12.1,8.7,12.6,8.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1c54a875c8c982b158b7dd03336db017.svg";
export { ForwardRef as ReactComponent };